import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { LayoutSelectors } from '@gestor-web/@core/store/selectors';
import { Store } from '@ngrx/store';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'bl-landing-page-component',
    templateUrl: './landing-page.component.html',
    styleUrls: ['./landing-page.component.scss'],
    standalone: false
})
export class LandingPageComponent implements OnDestroy {
  layoutConfig;

  constructor(private store: Store) {
    console.log('[LandingPageComponent] contructor');
    this.store
      .select(LayoutSelectors.selectLayoutState)
      .pipe(takeUntil(this.ngDestroyed$))
      .subscribe(config => {
        // console.log('[Store] layout/app.main - subscribe');
        this.layoutConfig = config;
      });
  }

  isOverlay() {
    return this.layoutConfig.menuMode === 'overlay';
  }

  isStatic() {
    return this.layoutConfig.menuMode === 'static';
  }

  isHorizontal() {
    return this.layoutConfig.menuMode === 'horizontal';
  }

  isSlim() {
    return this.layoutConfig.menuMode === 'slim';
  }

  private ngDestroyed$ = new Subject<void>();
  ngOnDestroy() {
    this.ngDestroyed$.next();
    this.ngDestroyed$.complete();
  }
}
